import { EColorVariablesV2 } from '@/types/theme-packs.types';

/* Note: if extending this, you need to also extend `channelThemeColors` inside of `use-create-theme-color-css-variables.ts` */
type ThemeVariables =
  | 'BG'
  | 'global-cont-1'
  | 'global-cont-2'
  | 'global-cont-3'
  | 'global-cont-4'
  | 'global-ico-text-1'
  | 'global-ico-text-2'
  | 'global-ico-text-3'
  | 'global-ico-text-4'
  | 'local-bttn-prim-default-bg';

const getProjectOverChannelColorCssVariable = (projectVariable?: EColorVariablesV2, themeVariable?: ThemeVariables) => {
  return `var(--project-theme-${projectVariable || EColorVariablesV2.primary}-over-channel-${themeVariable || 'global-cont-1'})`;
};

export default getProjectOverChannelColorCssVariable;
